import { cA as g, p as f, d as h, n as V, g as m, c as F, cB as A, cC as R, u as C, aa as _, f as E, h as j, o as P, Q as D, w as O, x as I, s as x, C as K, b4 as z } from "./VTextarea-a9029832.mjs";
import { capitalize as w, computed as L, h as G, ref as M, createVNode as v, toRef as Q } from "vue";
const B = (() => g.reduce((e, a) => (e[a] = {
  type: [Boolean, String, Number],
  default: !1
}, e), {}))(), T = (() => g.reduce((e, a) => {
  const t = "offset" + w(a);
  return e[t] = {
    type: [String, Number],
    default: null
  }, e;
}, {}))(), N = (() => g.reduce((e, a) => {
  const t = "order" + w(a);
  return e[t] = {
    type: [String, Number],
    default: null
  }, e;
}, {}))(), y = {
  col: Object.keys(B),
  offset: Object.keys(T),
  order: Object.keys(N)
};
function U(e, a, t) {
  let r = e;
  if (!(t == null || t === !1)) {
    if (a) {
      const n = a.replace(e, "");
      r += `-${n}`;
    }
    return e === "col" && (r = "v-" + r), e === "col" && (t === "" || t === !0) || (r += `-${t}`), r.toLowerCase();
  }
}
const W = ["auto", "start", "end", "center", "baseline", "stretch"], q = f({
  cols: {
    type: [Boolean, String, Number],
    default: !1
  },
  ...B,
  offset: {
    type: [String, Number],
    default: null
  },
  ...T,
  order: {
    type: [String, Number],
    default: null
  },
  ...N,
  alignSelf: {
    type: String,
    default: null,
    validator: (e) => W.includes(e)
  },
  ...h(),
  ...V()
}, "VCol"), ae = m()({
  name: "VCol",
  props: q(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const r = L(() => {
      const n = [];
      let o;
      for (o in y)
        y[o].forEach((c) => {
          const i = e[c], l = U(o, c, i);
          l && n.push(l);
        });
      const d = n.some((c) => c.startsWith("v-col-"));
      return n.push({
        // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
        "v-col": !d || !e.cols,
        [`v-col-${e.cols}`]: e.cols,
        [`offset-${e.offset}`]: e.offset,
        [`order-${e.order}`]: e.order,
        [`align-self-${e.alignSelf}`]: e.alignSelf
      }), n;
    });
    return () => {
      var n;
      return G(e.tag, {
        class: [r.value, e.class],
        style: e.style
      }, (n = t.default) == null ? void 0 : n.call(t));
    };
  }
}), ne = F("v-spacer", "div", "VSpacer"), H = f({
  ...h(),
  ...A()
}, "VForm"), re = m()({
  name: "VForm",
  props: H(),
  emits: {
    "update:modelValue": (e) => !0,
    submit: (e) => !0
  },
  setup(e, a) {
    let {
      slots: t,
      emit: r
    } = a;
    const n = R(e), o = M();
    function d(i) {
      i.preventDefault(), n.reset();
    }
    function c(i) {
      const l = i, s = n.validate();
      l.then = s.then.bind(s), l.catch = s.catch.bind(s), l.finally = s.finally.bind(s), r("submit", l), l.defaultPrevented || s.then((u) => {
        var k;
        let {
          valid: $
        } = u;
        $ && ((k = o.value) == null || k.submit());
      }), l.preventDefault();
    }
    return C(() => {
      var i;
      return v("form", {
        ref: o,
        class: ["v-form", e.class],
        style: e.style,
        novalidate: !0,
        onReset: d,
        onSubmit: c
      }, [(i = t.default) == null ? void 0 : i.call(t, n)]);
    }), _(n, o);
  }
});
const J = {
  actions: "button@2",
  article: "heading, paragraph",
  avatar: "avatar",
  button: "button",
  card: "image, heading",
  "card-avatar": "image, list-item-avatar",
  chip: "chip",
  "date-picker": "list-item, heading, divider, date-picker-options, date-picker-days, actions",
  "date-picker-options": "text, avatar@2",
  "date-picker-days": "avatar@28",
  divider: "divider",
  heading: "heading",
  image: "image",
  "list-item": "text",
  "list-item-avatar": "avatar, text",
  "list-item-two-line": "sentences",
  "list-item-avatar-two-line": "avatar, sentences",
  "list-item-three-line": "paragraph",
  "list-item-avatar-three-line": "avatar, paragraph",
  ossein: "ossein",
  paragraph: "text@3",
  sentences: "text@2",
  subtitle: "text",
  table: "table-heading, table-thead, table-tbody, table-tfoot",
  "table-heading": "chip, text",
  "table-thead": "heading@6",
  "table-tbody": "table-row-divider@6",
  "table-row-divider": "table-row, divider",
  "table-row": "text@6",
  "table-tfoot": "text@2, avatar@2",
  text: "text"
};
function X(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return v("div", {
    class: ["v-skeleton-loader__bone", `v-skeleton-loader__${e}`]
  }, [a]);
}
function S(e) {
  const [a, t] = e.split("@");
  return Array.from({
    length: t
  }).map(() => b(a));
}
function b(e) {
  let a = [];
  if (!e)
    return a;
  const t = J[e];
  if (e !== t) {
    if (e.includes(","))
      return p(e);
    if (e.includes("@"))
      return S(e);
    t.includes(",") ? a = p(t) : t.includes("@") ? a = S(t) : t && a.push(b(t));
  }
  return [X(e, a)];
}
function p(e) {
  return e.replace(/\s/g, "").split(",").map(b);
}
const Y = f({
  boilerplate: Boolean,
  color: String,
  loading: Boolean,
  loadingText: {
    type: String,
    default: "$vuetify.loading"
  },
  type: {
    type: [String, Array],
    default: "ossein"
  },
  ...E(),
  ...j(),
  ...P()
}, "VSkeletonLoader"), oe = m()({
  name: "VSkeletonLoader",
  props: Y(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: n
    } = D(Q(e, "color")), {
      dimensionStyles: o
    } = O(e), {
      elevationClasses: d
    } = I(e), {
      themeClasses: c
    } = x(e), {
      t: i
    } = K(), l = L(() => b(z(e.type).join(",")));
    return C(() => {
      var u;
      const s = !t.default || e.loading;
      return v("div", {
        class: ["v-skeleton-loader", {
          "v-skeleton-loader--boilerplate": e.boilerplate
        }, c.value, r.value, d.value],
        style: [n.value, s ? o.value : {}],
        "aria-busy": e.boilerplate ? void 0 : s,
        "aria-live": e.boilerplate ? void 0 : "polite",
        "aria-label": e.boilerplate ? void 0 : i(e.loadingText),
        role: e.boilerplate ? void 0 : "alert"
      }, [s ? l.value : (u = t.default) == null ? void 0 : u.call(t)]);
    }), {};
  }
});
const Z = f({
  withBackground: Boolean,
  ...h(),
  ...P(),
  ...V()
}, "VThemeProvider"), le = m()({
  name: "VThemeProvider",
  props: Z(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: r
    } = x(e);
    return () => {
      var n;
      return e.withBackground ? v(e.tag, {
        class: ["v-theme-provider", r.value, e.class],
        style: e.style
      }, {
        default: () => {
          var o;
          return [(o = t.default) == null ? void 0 : o.call(t)];
        }
      }) : (n = t.default) == null ? void 0 : n.call(t);
    };
  }
});
export {
  ne as V,
  ae as a,
  re as b,
  oe as c,
  le as d
};
